






























































































import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

import { Shop, Getaway, Tariff } from '../logic/types'

@Component
export default class ServiceCard extends Vue {
  @Prop() readonly tariff!: Tariff

  @Prop() readonly shop!: Shop

  @Prop() readonly tariffImage!: string | undefined

  @Prop({ type: Boolean, default: false }) multiplePayment!: boolean

  @Emit()
  selectTariff(): Tariff {
    return this.tariff
  }

  private isTariffDescriptionPopupOpen = false

  get shopValue(): Shop {
    const firstShop: Shop = (Object.keys(this.tariff.shops)[0]) as Shop
    return this.tariff.shops[this.shop] ? this.shop : firstShop
  }

  get getaway(): Getaway | null {
    return this.tariff.shops[this.shopValue]?.[0] ?? null
  }
}
